import { FC } from "react";

import { Paragraph } from "components/atoms/Paragraph/Paragraph";

import { TableRecord } from "@graphql/types/graphql";
import s from "./Table.module.scss";

export const Table: FC<TableRecord> = ({ table }) => (
  <Paragraph>
    <div className={s.Table} dangerouslySetInnerHTML={{ __html: table }} />
  </Paragraph>
);
